class CartPersonalisation {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      // Edit button clicked
      if (e.target.closest('[data-edit-message]')) {
        e.preventDefault();
        e.stopPropagation();
        const wrapper = e.target.closest('.cart-item__personalisation-wrapper');
        const accordion = wrapper.querySelector('.cart-item__personalisation-accordion');

        // Open accordion if closed
        if (!accordion.hasAttribute('open')) {
          accordion.setAttribute('open', '');
        }

        this.showEditForm(wrapper);
      }

      // Cancel button clicked
      if (e.target.closest('[data-cancel-edit]')) {
        const wrapper = e.target.closest('.cart-item__personalisation-wrapper');
        this.hideEditForm(wrapper);
      }

      // Save button clicked
      if (e.target.closest('[data-save-message]')) {
        const wrapper = e.target.closest('.cart-item__personalisation-wrapper');
        this.saveMessage(wrapper);
      }
    });

    // Character counter for textarea
    document.addEventListener('input', (e) => {
      if (e.target.matches('[data-message-input]')) {
        const wrapper = e.target.closest('.cart-item__personalisation-wrapper');
        const counter = wrapper?.querySelector('[data-message-counter]');
        if (counter) {
          counter.textContent = `${e.target.value.length}/30`;
        }
      }
    });
  }

  showEditForm(wrapper) {
    const display = wrapper.querySelector('[data-message-display]');
    const editForm = wrapper.querySelector('[data-message-edit]');

    if (display) display.setAttribute('hidden', '');
    if (editForm) {
      editForm.removeAttribute('hidden');
      // Focus the textarea
      const textarea = editForm.querySelector('[data-message-input]');
      if (textarea) textarea.focus();
    }
  }

  hideEditForm(wrapper) {
    const display = wrapper.querySelector('[data-message-display]');
    const editForm = wrapper.querySelector('[data-message-edit]');
    const textarea = editForm?.querySelector('[data-message-input]');
    const messageText = display?.querySelector('[data-message-text]');
    const originalText = messageText ? messageText.textContent : '';

    // Reset textarea to original value
    if (textarea) textarea.value = originalText;

    if (display) display.removeAttribute('hidden');
    if (editForm) editForm.setAttribute('hidden', '');
  }

  async saveMessage(wrapper) {
    const saveButton = wrapper.querySelector('[data-save-message]');
    const textarea = wrapper.querySelector('[data-message-input]');
    const itemKey = wrapper.getAttribute('data-cart-item-key');
    const variantId = wrapper.getAttribute('data-variant-id');
    const newMessage = textarea.value.trim();

    console.log('[CartPersonalisation] Starting save...');
    console.log('[CartPersonalisation] Item key from wrapper:', itemKey);
    console.log('[CartPersonalisation] Variant ID from wrapper:', variantId);
    console.log('[CartPersonalisation] New message:', newMessage);

    // Disable button during save
    saveButton.disabled = true;
    saveButton.textContent = 'Saving...';

    try {
      // First get current cart to find the item
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      console.log('[CartPersonalisation] Current cart items:', cart.items.map(i => ({
        key: i.key,
        variant_id: i.variant_id,
        quantity: i.quantity,
        properties: i.properties
      })));

      // Find the item in cart - try by key first, then by variant_id
      let cartItem = cart.items.find(i => i.key === itemKey);

      if (!cartItem && variantId) {
        console.log('[CartPersonalisation] Item not found by key, trying variant_id:', variantId);
        cartItem = cart.items.find(i => String(i.variant_id) === String(variantId));
      }

      console.log('[CartPersonalisation] Found cart item:', cartItem);

      if (!cartItem) {
        throw new Error('Item not found in cart');
      }

      // Get all current properties and update the Message
      const updatedProperties = { ...cartItem.properties, 'Message': newMessage || '' };

      console.log('[CartPersonalisation] Updated properties:', updatedProperties);

      // Update cart via Shopify Cart API using the CURRENT item key
      const updateData = {
        id: cartItem.key,  // Use the current key from cart (not the stale one from DOM)
        quantity: cartItem.quantity,
        properties: updatedProperties
      };

      console.log('[CartPersonalisation] Sending update:', updateData);

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData)
      });

      const result = await response.json();
      console.log('[CartPersonalisation] Response status:', response.status);
      console.log('[CartPersonalisation] Response body:', result);

      if (!response.ok) {
        throw new Error(result.description || 'Failed to update cart');
      }

      // Find the updated item to get its new key
      const updatedItem = result.items.find(i => String(i.variant_id) === String(cartItem.variant_id));
      if (updatedItem) {
        console.log('[CartPersonalisation] Updated item new key:', updatedItem.key);
        // Update the wrapper with the new key for future edits
        wrapper.setAttribute('data-cart-item-key', updatedItem.key);
      }

      // Update the display text if it exists
      const messageDisplay = wrapper.querySelector('[data-message-text]');
      if (messageDisplay) {
        messageDisplay.textContent = newMessage;
        // Hide edit form
        this.hideEditForm(wrapper);
      }

      // Trigger Shopify's cart update via pub/sub system to refresh the cart drawer
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-personalisation',
          cartData: result
        });
      }

    } catch (error) {
      console.error('[CartPersonalisation] Error updating message:', error);
      alert(error.message || 'Failed to update message. Please try again.');
    } finally {
      saveButton.disabled = false;
      saveButton.textContent = 'Save';
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CartPersonalisation();
  });
} else {
  new CartPersonalisation();
}
